module.exports = __webpack_public_path__ + "static/knittedheart2-90f181ae6562e8aa4bbd86ceb9ad308d.jpeg";